export const publishableKey = 'pk_test_51IbQRZDuEM1tZ8nq2eNlvgOZ6yExuCv51bPqGet5TZchxxPQfMRB0jeyAfZ87iPU5mDCey8OXQHLaOmaW3CHcgeh00Cizvo8CX';